// extracted by mini-css-extract-plugin
export var contentGrid = "_p-3";
export var divider = "_p-t";
export var emailInput = "_p-8";
export var emptyDescription = "_p-z";
export var emptyState = "_p-x";
export var emptyTitle = "_p-y";
export var fadeIn = "_p-10";
export var formCard = "_p-5";
export var formGroup = "_p-7";
export var helperText = "_p-9";
export var imagePlaceholder = "_p-n";
export var itemDetails = "_p-l";
export var itemImage = "_p-m";
export var itemInfo = "_p-p";
export var itemName = "_p-q";
export var itemPrice = "_p-s";
export var itemQuantity = "_p-r";
export var itemsList = "_p-j";
export var mainContent = "_p-4";
export var orderItem = "_p-k";
export var orderSummaryCard = "_p-i";
export var pageContainer = "_p-0";
export var pageHeader = "_p-1";
export var pageTitle = "_p-2";
export var paymentDescription = "_p-e";
export var paymentIcon = "_p-b";
export var paymentInfo = "_p-a";
export var paymentMethods = "_p-f";
export var paymentText = "_p-d";
export var placeholderText = "_p-o";
export var sectionTitle = "_p-6";
export var sidebarContent = "_p-h";
export var stripeIcon = "_p-c";
export var submitButton = "_p-g";
export var totalAmount = "_p-w";
export var totalLabel = "_p-v";
export var totalRow = "_p-u";